import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import {CARD_STYLE} from "../../../constants/styles";
import {CHART_CONTAINER_STYLE} from "../../../constants/styles";
import {CARD_HEADER_BACKGROUND} from "../../../constants/styles";
import {HEADER_FOOTER_COLOR} from "../../../constants/colors";
import { functions } from "../../../constants/common-functions";

import { useQuestionnaireAnalytics } from "../hooks/useQuestionnaireAnalytics";
import QuestionnaireCompletionIndicator from "./components/QuestionnaireCompletionIndicator";
import QuestionnaireCompletionBySurvey from "./components/QuestionnaireCompletionBySurvey";
import QuestionnaireAvgCompletionTime from "./components/QuestionnaireAvgCompletionTime";
import QuestionnaireCompletionTimeBySurvey from "./components/QuestionnaireCompletionTimeBySurvey";
import QuestionAnalysisPanel from "./components/QuestionAnalysisPanel";
import OutliersPanel from "./components/OutliersPanel";
import QuestionnaireModeSelector from "../QuestionnaireModeSelector";
import ScrollablePillSelector from "../../../components/ScrollablePillSelector";


export default function QuestionnaireQuestionAnalytics() {
	
	const [summary, setSummary] = useState(null);
	const [selectedQuestionnaireId, setSelectedQuestionnaireId] = useState(null);

	
	const questionnaires = summary ? summary.questionnaires : [];
	
	useEffect(function () {
	  if (!selectedQuestionnaireId && questionnaireItems.length > 0) {
	    setSelectedQuestionnaireId(questionnaireItems[0].id);
	  }
	}, [questionnaireItems, selectedQuestionnaireId]);
	
	useEffect(function () {
	  functions.getObjectFromAjax(
	    "/resolutionsoftwareplatform/questionnaire/analytics/summary",
	    function (data) {
	      setSummary(data);
	      if (data.questionnaires && data.questionnaires.length > 0) {
	        setSelectedQuestionnaireId(data.questionnaires[0].questionnaireId);
	      }
	    },
	    handleObj
	  );
	}, []);
	
	const handleObj = (obj) => {
		console.log("Analytics Summary");
		console.log(obj);
	}

	
	const cardHeader = {
		display:"flex",
		height:"20px",
		//backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		justifyContent:"space-between",
		alignItems:"center",
		borderTopLeftRadius:"10px",
		borderTopRightRadius:"10px",
		paddingTop:'5px',
		fontSize:'12px',
		color:'black',
		fontWeight:'bold',
		justifyContent:'space-around'
	};
	
	const cardChartContainer = {
		height:"calc(100% - 68px)",
		marginTop:'8px'
	}
	
	function safeAvg(values) {
	    if (!values || values.length === 0) return 0;
	    return values.reduce((a, b) => a + b, 0) / values.length;
	}

	function extractTrendValues(trend) {
	    if (!trend || trend.length === 0) return [];
	    return trend.map(t => t.value);
	}

	/* ===============================
	   Overall calculations
	   =============================== */

	function calculateOverallAveragePercent(summary) {
	    if (!summary || !summary.questionnaires) return 0;

	    return Math.round(
	        safeAvg(
	            summary.questionnaires.map(q => q.averagePercentComplete || 0)
	        )
	    );
	}

	function calculateOverallAverageCompletionMinutes(summary) {
	    if (!summary || !summary.questionnaires) return 0;

	    return Math.round(
	        safeAvg(
	            summary.questionnaires.map(q => q.averageCompletionMinutes || 0)
	        )
	    );
	}

	function calculateOverallPercentTrend(summary) {
	    if (!summary || !summary.questionnaires || summary.questionnaires.length === 0) {
	        return [];
	    }

	    // Use the *first questionnaire* as trend driver for now
	    return extractTrendValues(summary.questionnaires[0].completionPercentTrend);
	}

	function calculateOverallTimeTrend(summary) {
	    if (!summary || !summary.questionnaires || summary.questionnaires.length === 0) {
	        return [];
	    }

	    return extractTrendValues(summary.questionnaires[0].completionTimeTrend);
	}

	function calculateDeltaFromTrend(trend) {
	    if (!trend || trend.length < 2) return 0;
	    const last = trend[trend.length - 1];
	    const prev = trend[trend.length - 2];
	    return Math.round((last - prev) * 10) / 10;
	}
	
	
	const overallAveragePercentComplete =
	    calculateOverallAveragePercent(summary);

	const overallAverageCompletionMinutes =
	    calculateOverallAverageCompletionMinutes(summary);

	const overallCompletionPercentTrend =
	    calculateOverallPercentTrend(summary);

	const overallCompletionTimeTrend =
	    calculateOverallTimeTrend(summary);

	const overallPercentDelta =
	    calculateDeltaFromTrend(overallCompletionPercentTrend);

	const overallTimeDelta =
	    calculateDeltaFromTrend(overallCompletionTimeTrend);


	var questionnaireItems = [];

	if (summary && summary.questionnaires) {
	  questionnaireItems = summary.questionnaires.map(function (q) {
	    return {
	      id: q.questionnaireId,
	      label: q.title
	    };
	  });
	}
	
	return (
	   <>
		<div style={{ display: "flex", flexDirection: "column", width: "calc(100% - 60px)", marginLeft: "60px", marginTop: "60px" }}>
	       <Header/>
	       <LeftMenu />
		   
		   <div style={{display:'flex', width:'calc(100% - 20px)', flexWrap:'wrap', padding:'30px'}}>
		   	<div style={{ display: "flex", width: "calc(100% - 30px)", gap: "20px" }}>

		       <div style={{ ...CARD_STYLE, width: "300px", height: "200px", flexShrink: 0, flexDirection: "column" }}>
		           <div style={cardHeader}>Current Avg % Complete</div>
		           <div style={{...CHART_CONTAINER_STYLE, ...cardChartContainer}}>
				   <QuestionnaireCompletionIndicator
				       value={overallAveragePercentComplete}
				       delta={overallPercentDelta}
				       trend={overallCompletionPercentTrend}
				   />

		           </div>
		       </div>

		       <div style={{ ...CARD_STYLE, flex: 1, minWidth: 0, height: "200px", flexDirection: "column" }}>
		           <div style={cardHeader}>% Complete By Questionnaire</div>
				   <div style={{...CHART_CONTAINER_STYLE, ...cardChartContainer}}>
				   <QuestionnaireCompletionBySurvey
				       questionnaires={questionnaires}
				   />
   		           </div>
		       </div>

		       <div style={{ ...CARD_STYLE, width: "200px", height: "200px", flexShrink: 0, flexDirection: "column" }}>
		           <div style={cardHeader}>Avg Completion Time</div>
				   <div style={{...CHART_CONTAINER_STYLE, ...cardChartContainer}}>
				   <QuestionnaireAvgCompletionTime
				       minutes={overallAverageCompletionMinutes}
				       delta={overallTimeDelta}
				       trend={overallCompletionTimeTrend}
				   />

		           </div>
		       </div>

		       <div style={{ ...CARD_STYLE, flex: 1, minWidth: 0, height: "200px", flexDirection: "column" }}>
		           <div style={cardHeader}>Avg Completion Time By Questionnaire</div>
				   <div style={{...CHART_CONTAINER_STYLE, ...cardChartContainer}}>
 		               <QuestionnaireCompletionTimeBySurvey questionnaires={questionnaires} />
 		           </div>
		       </div>

		   	</div>
		   </div>
		   
		   {questionnaireItems.length > 0 && (
		     <ScrollablePillSelector
		       items={questionnaireItems}
		       selectedId={selectedQuestionnaireId}
		       onSelect={function (id) {
		         setSelectedQuestionnaireId(id);
		       }}
		     />
		   )}
	   		<div style={{...CARD_STYLE, width:'calc(100% - 50px)', minHeight:'800px', flexDirection:'column', marginLeft:'30px'}}>
				<div style={cardHeader}>
					Analysis by Question
				</div>
				<div style={{...CHART_CONTAINER_STYLE, ...cardChartContainer}}>
	               <QuestionAnalysisPanel />
	           </div>
				
				
			</div>
		</div>
		<OutliersPanel />
		<QuestionnaireModeSelector displayFlag="flex" />
		</>
	);   
}